export default "__VITE_ASSET__C0BzSb6___"